import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { ActionsOfType } from 'affiny-core/modules/helpers';
import {
  EMessagesActionType,
  messagesActions,
  TMessagesActions,
} from 'affiny-core/modules/messages/actions';
import { processNewMessageFromWebsocket } from 'affiny-core/modules/messages/saga';
import { messageSerializer } from 'affiny-core/modules/messages/serializers';
import { threadActions } from 'affiny-core/modules/threads/actions';
import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import {
  selectMessageIdsByThreadId,
  selectThreadIdByOtherAccountId,
} from 'affiny-core/redux/selectors/threadsSelectors';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

export function* processNewMessageFromWebsocketWeb(
  action: ActionsOfType<
    TMessagesActions,
    EMessagesActionType.NEW_MESSAGE_FROM_WEBSOCKET
  >
) {
  yield call(processNewMessageFromWebsocket, action);

  const receiverAboId = yield select(selectAccountId);
  const message = yield call(messageSerializer, action.payload, receiverAboId);

  const senderAccountId = message.attributes.myAccountId;
  const currentPathname = window.location.pathname;

  const isUserOnThreadPage = currentPathname.startsWith(
    `/inbox/${senderAccountId}`
  );

  if (isUserOnThreadPage) {
    yield put(threadActions.setThreadAsRead(senderAccountId));

    const threadId: string = yield select(
      selectThreadIdByOtherAccountId,
      senderAccountId
    );
    const messageIds = yield select(selectMessageIdsByThreadId, threadId);

    yield put(messagesActions.setMessagesAsRead(messageIds));
  }
}

export function* messagesSaga() {
  yield all([
    takeLatest(
      EMessagesActionType.NEW_MESSAGE_FROM_WEBSOCKET,
      handleAsyncStatus(
        processNewMessageFromWebsocketWeb,
        EAsyncEventTypes.NEW_MESSAGE_FROM_WEBSOCKET
      )
    ),
  ]);
}
